import { useTranslate } from '@repo/shared/hooks'
import { useAppForm } from '@repo/ui/hooks'

import { useLoginSchema } from '@repo/auth/schemas'
import { handleNumericInput, handlePasteInput } from '@repo/tools'
import {
  Button,
  Form,
  FormField,
  FormItemWrapper,
  Input,
} from '@repo/ui/components'
import { useEffect } from 'react'

interface LoginFormProps {
  onSuccess: (identifier: string, isEmail: boolean) => void
  loading?: boolean
}

export const LoginForm = ({ onSuccess, loading }: LoginFormProps) => {
  const { t } = useTranslate()
  const { identifierSchema } = useLoginSchema()
  const { form } = useAppForm({
    formSchema: identifierSchema,
  })

  const isMobile = form
    ?.watch('identifier')
    ?.slice(0, 1)
    .match(/[0-9۰-۹٠-٩]/)

  const onSubmit = (data: { identifier: string }) => {
    const value = data.identifier.trim()
    const isEmail = value.includes('@')
    onSuccess(value, isEmail)
  }

  useEffect(() => {
    form.setFocus('identifier')
  }, [form])

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className='space-y-3xl w-full'
      >
        <FormField
          control={form.control}
          name='identifier'
          render={({ field }) => (
            <FormItemWrapper
              title={t('loginPage_mobileOrEmail')}
              caption={t('loginPage_mobileStartsWithZero')}
              inputSize='lg'
            >
              <Input
                autoComplete='username'
                inputSize='lg'
                variant='fill'
                className={`ltr !min-h-[50px] !max-h-[50px] ${!isMobile ? 'font-[AzarMehr]' : ''}`}
                {...field}
                onKeyDown={(e) => {
                  if (/[0-9۰-۹٠-٩]/.test(e.key)) {
                    handleNumericInput(e, 11)
                  }
                }}
                onPaste={(e) => {
                  if (/[0-9۰-۹٠-٩]/.test(e.clipboardData.getData('text'))) {
                    handlePasteInput(e, 11)
                  }
                }}
              />
            </FormItemWrapper>
          )}
        />
        <Button
          className='w-full'
          type='submit'
          variant='fill'
          size='lg'
          loading={loading}
        >
          {t('common_continue')}
        </Button>
      </form>
    </Form>
  )
}
